import type * as ContractTypes from '@draftkings/dk-data-layer';
import { WildcardResponse } from '@draftkings/dk-data-layer';

export const formatWildcardResponseData = (data: WildcardResponse, currentOpenSectionId: string, subTabId: string) => {
    const key =
        data.sections.find((section) => section.id === currentOpenSectionId)?.subscriptionKey ||
        `EventGroup.${currentOpenSectionId}.Events`;

    return {
        tabs: new Map<string, ContractTypes.Tab>(data.tabs.map((tab) => [tab.id, tab])),
        subtabs: new Map<string, ContractTypes.SubTab>(data.subtabs.map((subtab) => [subtab.id, subtab])),
        sections: new Map<string, ContractTypes.Section>(
            data.sections.map((section) => [section.id, { ...section, isExpanded: false }])
        ),
        events: new Map<string, ContractTypes.SportEvent>(data.events.map((event) => [event.id, event])),
        markets: new Map<string, ContractTypes.Market>(data.markets?.map((market) => [market.id, market])),
        selections: new Map<string, ContractTypes.Selection>(
            data.selections?.map((selection) => [selection.id, selection])
        ),
        subscriptionPartials: {
            ...(data.subscriptionPartials[key] || {
                entity: 'events',
                query: `$filter=tags / any(t: t eq 'FeaturedSubcategory') and isLive eq true and clientMetadata/Subcategories/any(s: s/Id eq ${subTabId})&$orderBy=sortOrder asc`,
                includeMarkets: `$filter=clientMetadata/subCategoryId eq ${subTabId} and tags/any(t: t eq 'FeaturedSubcategory') and leagueId eq ${currentOpenSectionId}`
            })
        }
    };
};
